export enum GroupType {
    PMG,
    IPOC,
    Support,
    CPOC,
}
